import React from 'react';
import { useTranslation } from 'react-i18next';
import { Chevron } from '../icons/Chevron';
import { PartItem } from './PartItem';

export const PartsByArea = ({ zones, minor, onZone }) => {
    const { t } = useTranslation('reportPage');

    return (
        <div className="hcol-parts">
            <h3 className="h3">{t('history.partsByArea')}</h3>
            {zones.map(zone => (
                <div className={`zone${zone.on ? ' on' : ''}`} key={zone.key}>
                    <button type="button" className="zrow" aria-expanded={zone.on} onClick={() => onZone(zone.key)}>
                        <span className={`znum${zone.flag ? ' flag' : ''}`}>{zone.n}</span>
                        <span className="zname">
                            {zone.name}
                            <span className="zmeta">{zone.meta}</span>
                        </span>
                        {zone.flag && <span className="zflag">{t('history.redFlagTag')}</span>}
                        <Chevron open={zone.on} />
                    </button>
                    <div className={`zitems${zone.on ? '' : ' closed'}`}>
                        {zone.items.map(item => (
                            <PartItem item={item} key={`${item.component}-${item.km}-${item.visit}`} />
                        ))}
                    </div>
                </div>
            ))}
            {minor > 0 && (
                <span className="muted" style={{ alignSelf: 'flex-start' }}>
                    {t('history.minorItems', { count: minor })}
                </span>
            )}
        </div>
    );
};
